<div #angebotKachel role="region" aria-labelledby="angebot_title">
  <div
    class="d-flex"
    [ngClass]="{
      'justify-content-between': (isDesktop$ | async) === true,
      'justify-content-center': (isDesktop$ | async) === false
    }"
  >
    <div class="align-self-center me-3">
      @if ((isDesktop$ | async) === true) {
        <h3
          id="angebot_title"
          #heading
          tabindex="-1"
          nowWbsucheLibScrollToAndFocus
          [shouldFocus]="true"
          [innerHTML]="angebot.titel"
        ></h3>
      }
      @if (isDesktop$ | async) {
        <div class="fs-5">
          <span class="sr-only">Weiterbildungsart</span
          ><span aria-hidden="true"><i class="now-icon now-icon-certificate"></i></span
          >{{ weiterbildungsart }}
        </div>
      }
    </div>
    <img
      [attr.id]="'angebot_' + angebot.id + '_logo_right'"
      [src]="anbieterLogo"
      alt="Logo des Anbieters"
      class="logo-card mb-3"
      (error)="hasImgError = true"
    />
  </div>

  @if (isNowWbSuche) {
    <div class="now-toolbar now-toolbar-with-narrow-btns ps-1">
      <now-wbsuche-lib-favorit-toggle [entity]="favoriteEntity"></now-wbsuche-lib-favorit-toggle>
    </div>
  }
  <div id="angebot_inhalt">
    <now-wbsuche-lib-responsive-collapse
      [maxHeight]="164"
      [updateCollapse]="updateCollapse$"
      [collapseButtonText]="'zu den Weiterbildungsinhalten'"
    >
      @if ((showAfterInitialDelay$ | async) === true) {
        <h4 class="h5">Weiterbildungsinhalte</h4>
        <p
          class="anbieter_content"
          [attr.id]="'angebot_' + angebot.id + '_inhalte'"
          [innerHTML]="angebot.inhalt"
        ></p>
      }
    </now-wbsuche-lib-responsive-collapse>
  </div>
  <now-wbsuche-lib-termin-tabelle-kachel
    id="angebot_termine"
    [angebot]="angebot"
    (terminSelected)="selectTermin($event)"
  ></now-wbsuche-lib-termin-tabelle-kachel>
  <button
    id="focus_heading_btn"
    type="button"
    class="sr-only"
    aria-label="Zurück zum Angebotstitel"
    (click)="goToHeading()"
  ></button>
</div>
